export default "__VITE_ASSET__VMLr81m5__"